module.exports = __webpack_public_path__ + "img/treeplant8_7-8-2021.8b7a2e94.jpg";